<template>
  <div class="warning-block">
    <i class="iconfont yellow">&#xe65e;</i>
    <div class="text">
      <p class="warning-text">{{ $t('components.wthdraw.warning[0]') }}</p>
      <p class="warning-text">
        <span>{{ $t('components.wthdraw.warning[1]') }}</span>
        <router-link to="/aq/logisticsManage"><span>{{ $t('components.wthdraw.warning[2]') }}</span></router-link>
        <span>{{ $t('components.wthdraw.warning[3]') }}</span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WthdrawWarning',
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {}
}
</script>
<style lang='scss' scoped>
.warning-block {
  padding: 14px;
  font-family: PingFangSC-Regular;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.65);
  background: rgba(255, 193, 7, 0.2);
  border: 1px solid #ffc107;
  margin-bottom: 16px;
  text-align: left;
  display: flex;
  .yellow {
    color: #ffc107;
    font-size: 15px;
  }
  .warning-text {
    padding-left: 10px;
    a {
      color: #1fa0e8;
    }
  }
}
</style>
